import { reactive } from 'vue';

export const criarPrograma = () => {
    return reactive({
        id: 0,
        idmunicipio: 0,
        cdprograma: 0,
        nmprograma: '',
        dtinicio: '',
        dtfim: '',
        vlcupom: 0,
        vlcupom_cf: 0,
        vlcupom_nf: 0,
        vlcupom_np: 0,
        vlcupom_ns: 0,
        observacoes: '',
        ckativo: 'S',
        idlogin: 0,
        idusuario: 0
    });
};